module.exports = __webpack_public_path__ + "img/img-banner_1.7cc4147c.png";